import BkkDestroy from './index';

export default { path: '/home/bkk/destroy/record', component: BkkDestroy };
